import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Checkbox,
  FormGroup,
  MenuItem,
  Grid,
  FormControlLabel
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { COUNTRIES } from "../../../../../const";
const ParentForm = props => {
  const {
    setFieldValue,
    values,
    handleChange,
    index,
    touched,
    errors,
    handleBlur,
    style
  } = props;
  const { t } = useTranslation();

  return (
    <div>
      <h5>{t("add_kid.parents_info.parent_number", { number: Number(index) + 1 })}</h5>
      <Grid container spacing={24}>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.nom")}
              name={`parents[${index}][nom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][nom]`] &&
                    errors[`parents[${index}][nom]`]}
                </span>
              }
              value={values[`parents[${index}][nom]`]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.prenom")}
              name={`parents[${index}][prenom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][prenom]`] &&
                    errors[`parents[${index}][prenom]`]}
                </span>
              }
              value={values[`parents[${index}][prenom]`]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                name={`parents[${index}].usingKidAddress`}
                checked={values.parents[index].usingKidAddress}
                onChange={() => {
                  setFieldValue(
                    `parents[${index}].usingKidAddress`,
                    !values.parents[index].usingKidAddress
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][rue]`,
                    values.adresseDto.rue
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][ville]`,
                    values.adresseDto.ville
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][codePostale]`,
                    values.adresseDto.codePostale
                  );
                  setFieldValue(
                    `parents[${index}][adresseDto][pays]`,
                    values.adresseDto.pays
                  );
                }}
              />
            }
            label={t("add_kid.parents_info.use_kid_address")}
          />
        </Grid>
        <Grid item xs={8}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.rue")}
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}][adresseDto][rue]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["rue"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["rue"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["rue"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.ville")}
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}]["adresseDto"]["ville"]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["ville"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["ville"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["ville"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.code_postal")}
              variant="outlined"
              disabled={values.parents[index].usingKidAddress}
              name={`parents[${index}]["adresseDto"]["codePostale"]`}
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["codePostale"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["codePostale"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["codePostale"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              disabled={values.parents[index].usingKidAddress}
              label={t("add_kid.parents_info.pays")}
              variant="outlined"
              name={`parents[${index}]["adresseDto"]["pays"]`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.parents &&
                    touched.parents[index] &&
                    touched.parents[index]["adresseDto"] &&
                    touched.parents[index]["adresseDto"]["pays"] &&
                    errors.parents &&
                    errors.parents[index] &&
                    errors.parents[index]["adresseDto"] &&
                    errors.parents[index]["adresseDto"]["pays"]}
                </span>
              }
              value={values.parents[index]["adresseDto"]["pays"]}
            >
              {COUNTRIES.map(country => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.email")}
              name={`parents[${index}][email]`}
              type="email"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][email]`] &&
                    errors[`parents[${index}][email]`]}
                </span>
              }
              value={values.parents[index]["email"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.parents_info.telephone")}
              name={`parents[${index}][numeroTel]`}
              type="number"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched[`parents[${index}][numeroTel]`] &&
                    errors[`parents[${index}][numeroTel]`]}
                </span>
              }
              value={values.parents[index]["numeroTel"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label={t("add_kid.parents_info.sexe")}
              variant="outlined"
              name={`parents[${index}].sexe`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.parents[index]["sexe"]}
            >
              <MenuItem key="M" value="Masculin">
                {t("add_kid.parents_info.masculin")}
              </MenuItem>
              <MenuItem key="F" value="Feminin">
                {t("add_kid.parents_info.feminin")}
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label={t("add_kid.parents_info.situation")}
              variant="outlined"
              name={`parents[${index}].situation`}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.parents[index]["situation"]}
            >
              <MenuItem key="M" value="Marié">
                {t("add_kid.parents_info.marie")}
              </MenuItem>
              <MenuItem key="C" value="Célibataire">
                {t("add_kid.parents_info.celibataire")}
              </MenuItem>
              <MenuItem key="D" value="Divorcé">
                {t("add_kid.parents_info.divorce")}
              </MenuItem>
              <MenuItem key="V" value="Veuf">
                {t("add_kid.parents_info.veuf")}
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

ParentForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  style: PropTypes.object
};

export default ParentForm;
